import { makeConfig } from './config.common';

const config = makeConfig({
  DOMAIN: 'bikers.dating',
  TITLE: 'Bikers Dating',
  NICHE: 'bikers',
  PROJECT: 'bikersdating',
  NICHE_SINGULAR: 'biker',
  NICHE_PLURAL: 'bikers',
  FB_TRACKING_PIXEL_ID: [
    '277438316124462',
    '666147600552206',
    '296371352026935',
  ],
  BING_TRACKING_PIXEL: ['343094440'],
  SNAPCHAT_TRACKING_PIXEL: '3c5c6dec-f212-48d0-b122-fd0eb7b97d54',
  SNAPCHAT_HASHED_EMAIL:
    'e204fed6aff3d35c995bdf6883b099c14dd3b2271ade6d64169ddbfc29204e52',
  VERIZON_TRACKING_PIXEL: '10111267',
  TABOOLA_TRACKING_PIXEL: '1730669',
  RAYGUN_TRACKING_PIXEL: true,
  INSTALL_BANNER_KEY: '8e44c6cd-f371-4d65-b257-00a68dbef0f7',
  TYPE: 'mainstream',
  SENTRY_RELEASE: 'www-bikers-dating',
  SENTRY_DNS:
    'https://cd6679b80e68914cbe934835e5493276@sentry.nearbyapi.com/17',
  // SENTRY_DNS: 'https://7000a30d4f1c43ca9b3217cb64c141f6@o574863.ingest.sentry.io/5726384',
  VWO_ID: 302021,
});

export default config;



// WEBPACK FOOTER //
// ./src/constants/config.js